import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot } from "firebase/firestore";
import { useState, useEffect } from 'react';

const useUnreadChatsCount = () => {
    const [unreadCount, setUnreadCount] = useState(0);

    const firebaseConfig = {
        apiKey: "AIzaSyD0dRAy30uqOBPB8TG2Yt3MtGr5d07Dy5E",
        authDomain: "pnp-programa-nutricional.firebaseapp.com",
        databaseURL: "https://pnp-programa-nutricional.firebaseio.com",
        projectId: "pnp-programa-nutricional",
        storageBucket: "pnp-programa-nutricional.appspot.com",
        messagingSenderId: "739635922755",
        appId: "1:739635922755:web:49c1c5ec2ae5e18e5651f6",
        measurementId: "G-6Q2W3E05HV"
    };

    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);
    const db = getFirestore(firebaseApp);

    useEffect(() => {
        const usersCollectionRef = collection(db, 'users');

        const unsubscribe = onSnapshot(usersCollectionRef, (snapshot) => {
            let count = 0;
            snapshot.forEach((doc) => {
                const data = doc.data();
                if (!data.was_read_adm) {
                    count++;
                }
            });
            setUnreadCount(count);
        });

        return () => unsubscribe();
    }, []);

    return { unreadCount };
}

export { useUnreadChatsCount }
